import React from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@ubisend/pulse-hooks';
import { Select } from '@ubisend/pulse-components';

const format = ({ id, name }) => ({ label: name, value: id });

const MetricSelect = ({ value, currentlySelected, ...props }) => {
  const {
    data,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: [
      'custom-metrics/all'
    ]
  });

  const availableOptions = () => {
    return data.data.filter(
      item => !currentlySelected?.some(metric => metric.base.id === item.id)
    );
  };

  return (
    <Select
      isLoading={isLoading}
      options={isSuccess ? availableOptions().map(format) : []}
      isClearable
      value={
        isSuccess &&
        value &&
        format(data.data.find(metric => metric.id === value))
      }
      {...props}
    />
  );
};

MetricSelect.propTypes = {
  value: PropTypes.oneOf([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number
  ]),
  currentlySelected: PropTypes.object
};

export default MetricSelect;
